import { render } from "./PatientFindingFormModal.vue?vue&type=template&id=60d9b544"
import script from "./PatientFindingFormModal.vue?vue&type=script&lang=js"
export * from "./PatientFindingFormModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__